import { NetworkError } from "../store/NetworkError";

/**
 * auth_refresh Cookie を用いて新しい認証 Cookie を取得する。
 * 成功すれば Set-Cookie でブラウザに保存される (返り値なし)。
 */
export async function refreshUserToken(): Promise<void> {
    let res: Response;
    try {
        res = await fetch("/user-tokens/refresh", {
            method: "POST",
            credentials: "include",
        });
    } catch (e) {
        throw new NetworkError(e instanceof Error ? e.message : "Network error");
    }
    if (!res.ok) {
        throw new Error(`Refresh failed with status ${res.status}`);
    }
}
